import { render, staticRenderFns } from "./DocumentsForm.vue?vue&type=template&id=1434b65d&"
import script from "./DocumentsForm.vue?vue&type=script&lang=js&"
export * from "./DocumentsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports